export default "<div class=\"container\">\r\n  <img src=\"assets/placeholders/Analysis.png\">\r\n</div>"